import React from 'react'
import { UserRole } from '@/types'
import { ActorUsersPage } from '@/components/users/ActorUsersPage'
import { useUsersStore } from '@/stores/users.store'
import { useAuth } from '@/hooks/useAuth'
import { canManageNeoUsers } from '@/utils/role-access'

export const UsersPage: React.FC = () => {
  const users = useUsersStore(state => state.users)
  const fetchUsers = useUsersStore(state => state.fetchUsers)
  const addUser = useUsersStore(state => state.addUser)
  const updateUser = useUsersStore(state => state.updateUser)
  const deleteUser = useUsersStore(state => state.deleteUser)
  const { user } = useAuth()

  return (
    <ActorUsersPage
      title="Liste des utilisateurs"
      createButtonLabel="Nouvel utilisateur"
      gridCollection="users"
      users={users}
      fetchUsers={fetchUsers}
      onCreate={addUser}
      onUpdate={updateUser}
      onDelete={deleteUser}
      canManage={canManageNeoUsers(user)}
      allowedRoles={[UserRole.ADMIN, UserRole.VIEWER]}
      createTitle="Nouvel utilisateur"
      editTitle="Modifier l'utilisateur"
    />
  )
}
